import { z } from "zod";
const identifier = z.string().regex(/^[a-zA-Z_][a-zA-Z0-9_]{0,63}$/);
export const workflowNodeSchema = z.object({
    id: identifier,
    label: z.string().trim().min(1).max(120),
    kind: z.enum(["source", "transform", "judge", "rule", "review", "output"]),
    description: z.string().max(2000),
    inputs: z.array(identifier).max(32),
}).strict();
